<form [formGroup]="formGroup" (submit)="submit()">
    <div class="modal-header">
        <h5 class="modal-title">{{ 'reporting_ADD_COST_GROUP' | translate }}</h5>
        <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="activeModal.dismiss('Cancel')"></button>
    </div>
    <div class="modal-body">
        <p>{{ 'reporting_CREATE_A_NEW_COST_GROUP_MESSAGE' | translate }}</p>
        <app-input-text-group
            [maxLength]="255"
            [label]="'reporting_costgroup_enter_optional_group_name' | translate"
            formControlName="groupName" />
    </div>
    <div class="table-responsive">
        <app-costs-table
            [creatingMode]="true"
            [openForEdit]="true"
            [costUnitMap]="costUnitMap"
            [vatMap]="vatMap"
            [lineTextMap]="lineTextMap"
            [costSpecificationFormArray]="formGroup.controls.costSpecifications"></app-costs-table>
    </div>
    <div class="modal-body text-end">
        <button
            type="button"
            class="btn btn-text-primary"
            (click)="addCostSpecification(formGroup)">
            <i class="bi bi-plus"></i>{{ 'reporting_ADD_COST_LINE' | translate }}
        </button>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="activeModal.dismiss('Cancel')">
            {{ 'reporting_CANCEL' | translate }}
        </button>
        <button type="submit" class="btn btn-primary">
            {{ 'reporting_SAVE' | translate }}
        </button>
    </div>
</form>
